import { z } from 'zod';
import { workflowSchema } from './workflow';

export const workflowAgentProviderSchema = z.enum(['anthropic', 'ollama']);
export type WorkflowAgentProvider = z.infer<typeof workflowAgentProviderSchema>;

export const workflowAgentProviderConfigSchema = z.object({
    available: z.boolean(),
    defaultModel: z.string(),
});

export const workflowAgentConfigSchema = z.object({
    providers: z.object({
        anthropic: workflowAgentProviderConfigSchema,
        ollama: workflowAgentProviderConfigSchema,
    }),
    defaultProvider: workflowAgentProviderSchema,
});
export type WorkflowAgentConfig = z.infer<typeof workflowAgentConfigSchema>;

export const workflowAgentProposalRequestSchema = z.object({
    prompt: z.string().trim().min(1),
    provider: workflowAgentProviderSchema,
    model: z.string().trim().optional(),
    workflow: workflowSchema,
});
export type WorkflowAgentProposalRequest = z.infer<typeof workflowAgentProposalRequestSchema>;

export const workflowAgentProposalNodeSchema = z.object({
    id: z.string(),
    kind: z.string(),
    label: z.string(),
});
export type WorkflowAgentProposalNode = z.infer<typeof workflowAgentProposalNodeSchema>;

export const workflowAgentProposalSchema = z.object({
    summary: z.string(),
    workflow: workflowSchema,
    nodes: z.array(workflowAgentProposalNodeSchema),
    warnings: z.array(z.string()).default([]),
});
export type WorkflowAgentProposal = z.infer<typeof workflowAgentProposalSchema>;

export const workflowAgentProposalResponseSchema = z.object({
    message: z.string(),
    proposal: workflowAgentProposalSchema,
});
export type WorkflowAgentProposalResponse = z.infer<typeof workflowAgentProposalResponseSchema>;
